import React from "react";
import { Map, Marker, TileLayer, ZoomControl } from "react-leaflet";
// import FullscreenControl from "react-leaflet-fullscreen";
import "leaflet/dist/leaflet.css";

const MyMap = (props) => {
  const center = [35.7178, 51.407];
  return (
    <Map
      style={{
        height: "100%",
        width: "100%",
        direction: "ltr",
        borderRadius: "15px",
      }}
      zoom={16}
      center={center}
      className={"leaflet-map"}
      attributionControl={true}
      dragging={true}
      easeLinearity={0.35}
      scrollWheelZoom={true}
      zoomControl={false}
    >
      {/* <FullscreenControl
        position={"bottomright"}
        forceSeparateButton={true}
        className={"leaflet-control-zoom-fullscreen"}
      /> */}
      <ZoomControl position={"bottomright"} />
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {true && <Marker position={center}></Marker>}
    </Map>
  );
};

export default MyMap;
